export default {
  title: 'France, Belgium, Austria',
  presenter: 'fr_be_at',
  text: `
# Embassy of France + French - Slovak chamber of Commerce - Bratislava
## Michel Boivin - Economic Counsellor ( Embassy of France)

# Embassy of Belgium - Bratislava
## Bart Waterloos - Honorary Consulate in Bratislava

# Embassy of Austria + ABA Investment (Vienna)
## Birgit Reiter - Director Central and Eastern Europe

# Success story
## Touch4it -  Michal Korman (13 countries - Austria)
  `,
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/data/presentations/fr_be_at.js